import styled from 'styled-components'

const TableWrapper = styled.div`
    border-radius: 15px;
    border: solid 1px #87cdf1;
    height:96%;
    overflow: hidden;
    margin-bottom: 20px;
    box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
`

const Heading = styled.div`
   display: flex;
   align-items: center;
   background-color: #87CDF1;
   padding: 11px 10px 6px 16px;
   min-height: 66px;
   flex-wrap: wrap;
    gap: 10px;
    h3 {
        font-size: 20px;
    color: #000;
    font-family: 'latosemibold';
    flex-grow: 1;
    }
    justify-content: space-between;
`

const SearchWrapper = styled.div`
    display: flex;
    position: relative;
    border-radius: 4.2px;
    overflow: auto;
    width: 100%;
    margin: 0px 0px 30px 0px;
    input {
        background: #ffffff;
    border: none;
    padding: 4px 35px 4px 15px;
    width: 100%;
    ::-webkit-input-placeholder { /* Edge */
    color: #00000087;
}
`
const NameSection = styled.div`
    margin: 10px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding: 0px 40px 0px 21px;
    div{
        h6{
            font-size:22px;
            color:#005586;
        }
        span{
            font-size:12px;
        }
    }
    P{
        background: #005586;
        color: #fff;
        width: 21px;
        height: 21px;
        right: -1px;
        top: -6px;
        border-radius: 50%;
        font-size: 14px;
        text-align: center;
    }
`
const NameHeading = styled.div`
    margin: 14px;
    display: flex;
    justify-content: space-between;
    padding:15px;
    div{
        h6{
            margin: 1px 0px 0px 12px;
        }
        img {
            width: 39px;
            height: 45px;
        }
    }
`

export { TableWrapper, Heading, SearchWrapper, NameSection, NameHeading }